import { useTreeStore } from '@/stores/treeStore';

/**
 * Hook for checking data loading completion state (what IS loaded)
 * @param dataId - The data ID to check loading state for
 * @returns Object with boolean flags indicating what data is loaded
 */
export function useDataState(dataId: string | undefined) {
  const notesLoaded = useTreeStore((state) => (dataId ? state.notesLoaded.has(dataId) : false));
  const filesLoaded = useTreeStore((state) => (dataId ? state.filesLoaded.has(dataId) : false));
  const childrenLoaded = useTreeStore((state) => (dataId ? state.childrenLoaded.has(dataId) : false));

  return { notesLoaded, filesLoaded, childrenLoaded };
}

/**
 * Hook for tracking data action state (what's currently BEING done)
 * @param dataId - The data ID to check action state for
 * @returns Object with boolean flags indicating what actions are in progress
 */
export function useDataActions(dataId: string | undefined) {
  const isDeleting = useTreeStore((s) => (dataId ? (s.loading.get(`delete-${dataId}`) ?? false) : false));
  const isSubmitting = useTreeStore((s) => (dataId ? (s.loading.get(`submit-${dataId}`) ?? false) : false));
  const isResetting = useTreeStore((s) => (dataId ? (s.loading.get(`reset-${dataId}`) ?? false) : false));
  const isLoadingFiles = useTreeStore((s) => (dataId ? (s.loading.get(`files-${dataId}`) ?? false) : false));
  const isLoadingNotes = useTreeStore((s) => (dataId ? (s.loading.get(`notes-${dataId}`) ?? false) : false));
  const isLoadingChildren = useTreeStore((s) => (dataId ? (s.loading.get(`expand-${dataId}`) ?? false) : false));
  const isInitializing = useTreeStore((s) => (dataId ? (s.loading.get(`init-${dataId}`) ?? false) : false));

  return {
    isDeleting,
    isSubmitting,
    isResetting,
    isLoadingFiles,
    isLoadingNotes,
    isLoadingChildren,
    isInitializing,
  };
}
